module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Bold.5eacbf57.woff2";